import { render } from "./WikiLogo.vue?vue&type=template&id=7a97777c&scoped=true"
import script from "./WikiLogo.vue?vue&type=script&lang=js"
export * from "./WikiLogo.vue?vue&type=script&lang=js"

import "./WikiLogo.vue?vue&type=style&index=0&id=7a97777c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a97777c"]])

export default __exports__